import { useWorkspace } from "@/contexts/WorkspaceContext";
import type { Workspace } from "@/types/workspace";

/** Owners and admins manage a workspace's billing, members and invites; editors build. No workspace yet means the user's own account, which they always manage. */
export const canManageWorkspace = (workspace: Workspace | null | undefined): boolean =>
  !workspace || workspace.type === "personal" || workspace.role === "owner" || workspace.role === "admin";

// Tolerates a missing provider (modals rendered alone in tests): no workspace means the user's own account
export const useCanManageBilling = (): boolean => {
  let workspace: Workspace | null = null;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- always called exactly once; the try only absorbs the missing-provider throw
    workspace = useWorkspace().activeWorkspace;
  } catch {
    workspace = null;
  }
  return canManageWorkspace(workspace);
};

export const ASK_ADMIN_FOR_CREDITS = "Ask an owner or admin of this workspace to add credits.";
export const ASK_ADMIN_FOR_PLAN = "Only owners and admins can change this workspace's plan.";
